import { render, staticRenderFns } from "./HonorLineStaffConfig.vue?vue&type=template&id=63dc155c&scoped=true"
import script from "./HonorLineStaffConfig.vue?vue&type=script&lang=js"
export * from "./HonorLineStaffConfig.vue?vue&type=script&lang=js"
import style0 from "./HonorLineStaffConfig.vue?vue&type=style&index=0&id=63dc155c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dc155c",
  null
  
)

export default component.exports